import { useQuery } from '@apollo/react-hooks';

import { toQuizFeedReportVariables } from 'Domains/adaptiveQuiz';
import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getQuizFeedAttemptReport } from 'GraphQL/queries/report.query';

const QuizFeedAttemptReportData = ({ value, schoolCode, username, children }) => {
  const { term, grade, classNo, subject, syllabus, lesson, mode } = value;

  const isSkip =
    !term ||
    !grade ||
    !classNo ||
    !subject ||
    !syllabus ||
    !lesson ||
    !username ||
    !schoolCode ||
    mode !== SYLLABUS_MODE.TUNGKAI;

  const { loading, error, data, refetch, networkStatus } = useQuery(getQuizFeedAttemptReport, {
    variables: { ...toQuizFeedReportVariables(value), classroomUsername: username, schoolCode },
    skip: isSkip,
    notifyOnNetworkStatusChange: true,
  });

  return children({ loading, error, data, refetch, networkStatus });
};

export default QuizFeedAttemptReportData;
